class VoiceContentData {
  constructor(categoryName, categoryValue, voiceName, voiceValue, voiceSrc) {
    this.categoryName = categoryName;
    this.categoryValue = categoryValue;
    this.voiceName = voiceName;
    this.voiceValue = voiceValue;
    this.voiceSrc = voiceSrc;
  }
  categoryName;
  categoryValue;
  voiceName;
  voiceValue;
  voiceSrc;
}

export { VoiceContentData };
//# sourceMappingURL=data.js.map
